import React from 'react';
import "./HomePage.css"
const ScrollDown = () => {
    return (
        <div className="scroll__down">
            <a href="#about" className="mouse__wrapper">
                <span className="home__scroll-name dark:text-white">Scroll Down</span>
                <span className="mouse dark:text-white">
                    <span className="wheel dark:bg-white"></span>
                </span>
            </a>
        </div>
    )
}

export default ScrollDown;